<template>
  <transition name="slide">
    <div
      v-if="openPreview"
      :class="
        thirdPartyData.configuration.jobApprovalStage &&
        thirdPartyData.configuration.jobApprovalStage === 'BASIC_INFO'
          ? 'newJD-slide-hiring-container'
          : 'newJD-slide-container'
      "
    >
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="position-absolute pointer newJD-backArrow">
            <img
              @click="$emit('close-review-jds')"
              src="../../assets/img/accessconnew/boxBackArrow.svg"
              alt
            />
          </div>
          <div v-if="isPending" class="newJD-heading ml-3 pt-1">Review Job</div>
          <div v-else class="newJD-heading ml-3 pt-1">Preview Job</div>
          <div class="rotate-on-hover pointer">
            <img
              v-b-tooltip.hover.top="'Close'"
              @click="$emit('close-review-jds')"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="mb-0 mt-0" />
        <div
          class="d-flex w-100"
          :class="isPending ? 'newJD-overflow' : 'newJD-preview-overflow'"
        >
          <div
            :class="
              thirdPartyData.configuration.jobApprovalStage &&
              thirdPartyData.configuration.jobApprovalStage === 'BASIC_INFO'
                ? 'pr-0'
                : 'pr-3'
            "
            :style="{
              width:
                thirdPartyData.configuration.jobApprovalStage &&
                thirdPartyData.configuration.jobApprovalStage === 'BASIC_INFO'
                  ? '100%'
                  : '40%',
            }"
          >
            <div class="newJD-left-container w-100">
              <div class="newJD-head">Basic Details</div>
              <div
                :class="
                  isPending
                    ? 'newJD-left-inner-container'
                    : 'newJD-left-inner-container-preview'
                "
              >
                <div
                  :class="i !== 0 ? 'mt-3' : ''"
                  v-for="(field, i) in filteredCustFields"
                  :key="field.key + i"
                >
                  <div class="newInt-rs-head">{{ field.label }}</div>
                  <div class="newInt-rs-subhead wordbreak mt-1">
                    <div v-if="checkFieldKeys(field)">-</div>
                    <div
                      style="word-break: keep-all"
                      v-else-if="Object.keys(jobDetail).length > 0"
                    >
                      <template v-if="isHtmlContent(field)">
                        <div v-html="checkValuesOfKey(field)"></div>
                      </template>
                      <template v-else>
                        {{ checkValuesOfKey(field) }}
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !(
                thirdPartyData.configuration.jobApprovalStage &&
                thirdPartyData.configuration.jobApprovalStage === 'BASIC_INFO'
              )
            "
            class="newJD-right-container"
          >
            <div class="newInt-control-tabs w-100">
              <b-tabs>
                <b-tab title="Interview Process" class="pr-1">
                  <div
                    :class="
                      isPending
                        ? 'newJD-right-innerContent'
                        : 'newJD-right-innerContent-preview'
                    "
                  >
                    <div class="d-flex align-items-end">
                      <div class="newJD-right-Intfont adjust-intProcess-head">
                        Interview Process:
                      </div>
                      <div class="newJD-right-Intfont-subHead wordbreak w-80">
                        {{ ipname }}
                      </div>
                    </div>
                    <div v-for="(data, index) in noofrounds" :key="index">
                      <!-- if unselected -->
                      <template v-if="!data.expanded">
                        <div
                          v-if="
                            data.id != 0 &&
                            data.id != 'F' &&
                            data.id != 'H' &&
                            data.id != 'NI' &&
                            data.id != 'R'
                          "
                          class="mt-2"
                        >
                          <div
                            class="
                              newJD-int-container
                              d-flex
                              align-items-center
                              justify-content-between
                              pointer
                            "
                            @click="toggleExpanded(data.id)"
                          >
                            <div class="newJD-int-mainhead text-truncate w-72">
                              {{ data.name }}
                            </div>
                            <div
                              class="
                                d-flex
                                align-items-center
                                newJD-int-mainhead-rightside
                              "
                            >
                              <div v-if="data.type == 'assesment'" class="mr-3">
                                Assessment
                              </div>
                              <div v-if="data.type == 'f2f'" class="mr-3">
                                Face to Face
                              </div>
                              <div>
                                <img
                                  src="../../assets/newJD/newJD-downArrow.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- if selected -->
                      <template v-if="data.expanded">
                        <div
                          v-if="
                            data.id != 0 &&
                            data.id != 'F' &&
                            data.id != 'H' &&
                            data.id != 'NI' &&
                            data.id != 'R'
                          "
                          class="mt-2 newJD-int-container p-0"
                        >
                          <div
                            class="
                              newJD-int-container-selected
                              d-flex
                              align-items-center
                              justify-content-between
                              pointer
                            "
                            @click="toggleExpanded(data.id)"
                          >
                            <div class="newJD-int-mainhead text-truncate w-72">
                              {{ data.name }}
                            </div>
                            <div
                              class="
                                d-flex
                                align-items-center
                                newJD-int-mainhead-rightside
                              "
                            >
                              <div v-if="data.type == 'assesment'" class="mr-3">
                                Assessment
                              </div>
                              <div v-if="data.type == 'f2f'" class="mr-3">
                                Face to Face
                              </div>
                              <div>
                                <img
                                  src="../../assets/newJD/newJD-upArrow.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div class="p-3">
                            <div class="w-100 d-flex align-items-center">
                              <div class="d-flex align-items-center w-50">
                                <div class="w-50 d-flex align-items-center">
                                  <img
                                    src="../../assets/new-calender-icon.svg"
                                    alt=""
                                  />
                                  <div class="newJD-selected-date-head ml-2">
                                    {{
                                      data.type == "assesment"
                                        ? "Start Date & Time:"
                                        : "Start Date:"
                                    }}
                                  </div>
                                </div>
                                <div
                                  v-if="data.type === 'assesment'"
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{
                                    getConverted(data.openTestdt)
                                      | formatAssesmentDate
                                  }}
                                </div>
                                <div
                                  v-else-if="data.type === 'f2f'"
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{
                                    data.startDate.substring(0, 10) | formatdate
                                  }}
                                </div>
                              </div>
                              <div class="d-flex align-items-center w-50">
                                <div class="w-50 d-flex align-items-center">
                                  <img
                                    src="../../assets/new-calender-icon.svg"
                                    alt=""
                                  />
                                  <div
                                    class="newJD-selected-date-head ml-2"
                                    :class="
                                      data.type == 'assesment'
                                        ? 'set-width-assessment'
                                        : ''
                                    "
                                  >
                                    {{
                                      data.type == "assesment"
                                        ? `End Date & Time:`
                                        : "End Date:"
                                    }}
                                  </div>
                                </div>
                                <div
                                  v-if="data.type === 'assesment'"
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{
                                    getConverted(data.closeTestdt)
                                      | formatAssesmentDate
                                  }}
                                </div>
                                <div
                                  v-else-if="data.type === 'f2f'"
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{
                                    data.endDate.substring(0, 10) | formatdate
                                  }}
                                </div>
                              </div>
                            </div>
                            <div class="w-100 d-flex align-items-center mt-3">
                              <div class="d-flex align-items-center w-50">
                                <div class="w-50 d-flex align-items-center">
                                  <img
                                    src="../../assets/newJD/bu-head-duration.svg"
                                    alt=""
                                  />
                                  <div
                                    class="newJD-selected-date-head ml-2"
                                    :class="
                                      data.type == 'assesment'
                                        ? 'set-width-duration'
                                        : ''
                                    "
                                  >
                                    Duration (min):
                                  </div>
                                </div>
                                <div
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{ data.duration ? data.duration : "-" }}
                                </div>
                              </div>
                              <div
                                v-if="data.type == 'assesment'"
                                class="d-flex align-items-center w-50"
                              >
                                <div class="w-50 d-flex align-items-center">
                                  <img
                                    src="../../assets/newJD/bu-head-passing-percentage.svg"
                                    alt=""
                                  />
                                  <div class="newJD-selected-date-head ml-2">
                                    Passing Percentage:
                                  </div>
                                </div>
                                <div
                                  class="
                                    w-50
                                    d-flex
                                    align-items-center
                                    newJD-selected-date-subhead
                                  "
                                >
                                  {{ data.passingPercentage + `%` }}
                                </div>
                              </div>
                              <div
                                v-if="data.type === 'f2f'"
                                class="d-flex align-items-center w-50"
                              >
                                <img
                                  v-if="data.jdDetailsType !== 0"
                                  src="../../assets/newJD/newJD-right-tick.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/newJD/bu-head-job-details-withheld.svg"
                                  alt=""
                                />
                                <span
                                  v-if="data.jdDetailsType == 0"
                                  class="newJD-selected-date-head w-50 ml-2"
                                >
                                  Job details withheld from panelist
                                </span>
                                <span
                                  v-if="data.jdDetailsType == 1"
                                  class="newJD-selected-date-head w-50 ml-2"
                                >
                                  Job details shown to panelist (Basic)
                                </span>
                                <span
                                  v-else-if="data.jdDetailsType == 2"
                                  class="newJD-selected-date-head ml-2"
                                >
                                  Job details shown to panelist (All)
                                </span>
                                <span
                                  v-if="
                                    data.jdDetailsType == 1 ||
                                    data.jdDetailsType == 2
                                  "
                                  @click="
                                    getPanelJdDetails(
                                      data.id,
                                      data.jdDetailsType
                                    )
                                  "
                                  class="newJD-selected-view-font ml-3 pointer"
                                >
                                  <u> View </u>
                                </span>
                              </div>
                            </div>

                            <hr v-if="data.type == 'assesment'" />
                            <div v-if="data.type == 'assesment'">
                              <div class="newJD-testName">Test Details</div>
                              <div
                                v-for="test in data.selectedtests"
                                :key="test.testID"
                                class="mt-2 newJD-test-container"
                              >
                                <div
                                  class="newJD-selected-date-head test-truncate"
                                >
                                  Test Name
                                </div>
                                <div class="newJD-test-head-sub">
                                  {{ test.name }}
                                </div>
                                <hr class="mt-2 mb-2" />
                                <div
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                  "
                                >
                                  <div>
                                    <div class="newJD-test-dateFont">
                                      Difficulty
                                    </div>
                                    <div
                                      class="
                                        newJD-test-dateFont-subhead
                                        text-center
                                      "
                                    >
                                      {{ test.difficultyLevel }}
                                    </div>
                                  </div>

                                  <div>
                                    <div class="newJD-test-dateFont">
                                      Sections
                                    </div>
                                    <div
                                      class="
                                        newJD-test-dateFont-subhead
                                        text-center
                                      "
                                    >
                                      {{ test.numberOfSections }}
                                    </div>
                                  </div>

                                  <div>
                                    <div class="newJD-test-dateFont">
                                      Questions
                                    </div>
                                    <div
                                      class="
                                        newJD-test-dateFont-subhead
                                        text-center
                                      "
                                    >
                                      {{ test.noOfQuestions }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="mt-3" v-if="data.type == 'assesment'">
                              <div class="newJD-testName">Configuration</div>
                              <div class="mt-2 newJD-test-container">
                                <div
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    w-100
                                  "
                                >
                                  <div
                                    class="
                                      newJD-selected-date-head
                                      text-truncate
                                    "
                                  >
                                    {{ data.configName }}
                                  </div>
                                  <div
                                    @click="viewConfig(index)"
                                    class="newJD-selected-view-font pointer"
                                  >
                                    View
                                  </div>
                                </div>
                                <hr class="mt-2 mb-2" />
                                <div
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    w-100
                                  "
                                >
                                  <div>
                                    <div class="newJD-test-dateFont">
                                      Start Date
                                    </div>
                                    <div class="newJD-test-dateFont-subhead">
                                      {{
                                        getConverted(data.openTestdt)
                                          | formatAssesmentDate
                                      }}
                                    </div>
                                  </div>

                                  <div>
                                    <div class="newJD-test-dateFont">
                                      End Date
                                    </div>
                                    <div class="newJD-test-dateFont-subhead">
                                      {{
                                        getConverted(data.closeTestdt)
                                          | formatAssesmentDate
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="mt-3" v-if="data.type == 'assesment'">
                              <div class="newJD-testName">Evaluators</div>
                              <div class="d-flex align-items-center flex-wrap">
                                <div
                                  v-if="
                                    data.selevaluator &&
                                    data.selevaluator.length == 0
                                  "
                                  class="newJD-allocate-emptydata mt-2 ml-2"
                                >
                                  No evaluators allocated
                                </div>
                                <div
                                  v-else
                                  v-for="evaluator in data.selevaluator"
                                  :key="evaluator.evaluatorID"
                                  class="
                                    teams-addUser-container-rightContent
                                    mt-2
                                    ml-2
                                  "
                                >
                                  {{ evaluator.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Allocation" class="pr-1">
                  <div class="newJD-allocate-overflow">
                    <div class="p-2">
                      <div class="newJD-allocate-head ml-2">Recruiters</div>
                      <div
                        v-if="
                          jobDetail.assignedTo &&
                          jobDetail.assignedTo.length == 0
                        "
                        class="newJD-allocate-emptydata mt-2 ml-2"
                      >
                        {{
                          jobDetail.recruiterConfig.selectAll
                            ? "All recruiters allocated"
                            : "No recruiters allocated"
                        }}
                      </div>
                      <div v-else class="d-flex align-items-center flex-wrap">
                        <div
                          v-for="recruiter in jobDetail.assignedTo"
                          :key="recruiter.userID"
                          class="teams-addUser-container-rightContent mt-2 ml-2"
                        >
                          {{ recruiter.username }}
                        </div>
                      </div>
                    </div>
                    <div class="p-2 mt-2">
                      <div class="newJD-allocate-head ml-2">Panelist</div>
                      <div
                        v-if="
                          jobDetail.assignedPanelist &&
                          jobDetail.assignedPanelist.length === 0
                        "
                        class="newJD-allocate-emptydata mt-2 ml-2"
                      >
                        {{
                          jobDetail.showAllPanelist
                            ? "All panelists allocated"
                            : "No panelists allocated"
                        }}
                      </div>

                      <div v-else class="d-flex align-items-center flex-wrap">
                        <div
                          v-for="panel in jobDetail.assignedPanelist"
                          :key="panel.userID"
                          class="teams-addUser-container-rightContent mt-2 ml-2"
                        >
                          {{ panel.username }}
                        </div>
                      </div>
                    </div>
                    <div class="p-2 mt-2">
                      <div class="newJD-allocate-head ml-2">Vendors</div>
                      <div
                        v-if="jobDetail.vendor && jobDetail.vendor.length == 0"
                        class="newJD-allocate-emptydata mt-2 ml-2"
                      >
                        No vendors allocated
                      </div>
                      <div v-else class="d-flex align-items-center flex-wrap">
                        <div
                          v-for="vendor in jobDetail.vendor"
                          :key="vendor.vendorID"
                          class="teams-addUser-container-rightContent mt-2 ml-2"
                        >
                          {{ vendor.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="History" class="pr-1">
                  <div class="p-3 newJD-allocate-overflow">
                    <div class="newJD-history-container">
                      <div
                        v-for="(history, i) in jobDetail.activity"
                        :key="i"
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                          w-100
                          h-100
                        "
                      >
                        <div
                          v-if="history.status != 'Created Draft'"
                          class="d-flex w-100 h-100 relativeclass"
                        >
                          <div style="width: 5%">
                            <div class="newJD-lock-box-image">
                              <img
                                class="d-flex"
                                src="../../assets/New-imgs/interviewProcess-icons/newInt-round-circle.svg"
                                alt=""
                              />
                            </div>
                            <div
                              v-if="i != jobDetail.activity.length - 1"
                              class="newJD-lock-box"
                            ></div>
                          </div>

                          <div
                            class="d-flex"
                            style="width: 95%"
                            :class="i !== 0 ? 'mt-3' : 'mt-0'"
                          >
                            <div
                              class="
                                newJD-allocate-pic
                                d-flex
                                align-items-center
                                justify-content-center
                              "
                              style="width: 43px"
                            >
                              {{ history.userIcon }}
                            </div>
                            <div class="ml-2" style="width: 92%">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                  w-100
                                "
                              >
                                <div class="newJD-history-head">
                                  {{ history.name }}
                                </div>
                                <div
                                  class="newJD-accepted-font"
                                  v-if="
                                    history.movedTo == 1 || history.movedTo == 3
                                  "
                                >
                                  {{ history.status }}
                                </div>
                                <div
                                  class="newJD-sentforapproval-font"
                                  v-else-if="history.movedTo == 2"
                                >
                                  {{ history.status }}
                                </div>
                                <div class="newJD-rejected-font" v-else>
                                  {{ history.status }}
                                </div>
                              </div>
                              <div class="newJD-history-subhead wordbreak mt-1">
                                {{ history.time.substring(0, 10) | formatdate }}
                              </div>
                              <div
                                v-if="history.remarks != ''"
                                class="newJD-history-subhead mt-1"
                              >
                                Remarks :
                              </div>
                              <div
                                v-if="history.remarks != ''"
                                class="mt-1 newJD-remarks-content"
                              >
                                {{ history.remarks }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Publish Job" class="pr-1">
                  <div class="p-3 newJD-allocate-overflow">
                    <!-- Platforms Section -->
                    <section v-if="hasPlatforms" class="w-100">
                      <div class="pubjobs-head fw-500 mb-3">Platform:</div>
                      <div class="d-flex flex-wrap w-100">
                        <template v-for="platform in platforms">
                          <div
                            v-if="platform.condition"
                            :key="platform.name"
                            class="
                              d-flex
                              align-items-center
                              fw-600
                              pubjobs-head
                              w-50
                            "
                          >
                            <img :src="platform.icon" alt="" />
                            <img
                              src="@/assets/publishJobs/line.svg"
                              class="mx-2"
                              alt=""
                            />
                            <div>{{ platform.label }}</div>
                          </div>
                        </template>
                      </div>
                      <hr />
                    </section>

                    <!-- Notifications Section -->
                    <section v-if="hasNotifications" class="w-100">
                      <div class="pubjobs-head fw-500 mb-3">Notifications:</div>
                      <div class="d-flex flex-wrap w-100">
                        <template v-for="note in notifications">
                          <div
                            v-if="note.condition"
                            :key="note.name"
                            class="
                              d-flex
                              align-items-center
                              fw-600
                              pubjobs-head
                              w-50
                            "
                          >
                            <img :src="note.icon" alt="" />
                            <div class="ml-2">{{ note.label }}</div>
                          </div>
                        </template>
                      </div>
                      <hr />
                    </section>

                    <!-- Threshold & Settings -->
                    <section>
                      <div
                        v-if="jobDetail.customFields.threshold"
                        class="pubjobs-head fw-500 mb-2"
                      >
                        Applicants qualification threshold:
                        <span class="pubjobs-subheads fw-600">
                          {{ jobDetail.customFields.threshold }}%
                        </span>
                      </div>

                      <div
                        v-if="jobDetail.customFields.maxCheatingPercentage"
                        class="pubjobs-head fw-500 mb-3"
                      >
                        Minimum Assessment Cheating:
                        <span class="pubjobs-subheads fw-600">
                          {{ jobDetail.customFields.maxCheatingPercentage }}%
                        </span>
                      </div>

                      <div
                        class="d-flex my-2"
                        :class="{
                          'align-items-baseline':
                            jobDetail.customFields.automatic,
                        }"
                      >
                        <div>
                          <img
                            :src="
                              jobDetail.customFields.automatic
                                ? greenTick
                                : xMark
                            "
                            alt=""
                          />
                        </div>
                        <div class="pubjobs-head fw-500 ml-1">
                          Do you want this recruitment process to be automated?
                        </div>
                        <div
                          class="position-relative"
                          @mouseenter="showTooltipPlace = 'first'"
                          @mouseleave="
                            (showTooltipPlace = null),
                              !jobData.automatic ? scrollToBottom() : ''
                          "
                        >
                          <img
                            src="@/assets/img/info-icon-publish.svg"
                            class="ml-2 pb-1"
                            alt=""
                          />
                          <div
                            v-if="showTooltipPlace == 'first'"
                            class="cs-tooltip-place"
                          >
                            <div class="mt-1">
                              Turn on to automate assessments and<br />
                              schedule interviews with Hire3x panelists,<br />
                              based on available credits.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="d-flex mt-2"
                        :class="{
                          ' align-items-baseline':
                            jobDetail.customFields.manualReview,
                        }"
                      >
                        <img
                          :src="
                            jobDetail.customFields.manualReview
                              ? greenTick
                              : xMark
                          "
                          alt=""
                        />
                        <div class="pubjobs-head fw-500 ml-1">
                          Manual Review of applications Required?
                        </div>
                        <div
                          @mouseenter="showTooltipPlace = 'second'"
                          @mouseleave="showTooltipPlace = null"
                          class="position-relative"
                        >
                          <img
                            src="@/assets/img/info-icon-publish.svg"
                            class="ml-2 pb-1"
                            alt=""
                          />
                          <div
                            v-if="showTooltipPlace == 'second'"
                            class="cs-tooltip-place"
                          >
                            <div class="mt-1">
                              Enable to manually move<br />
                              Hire3xAI-qualified candidates to<br />
                              Round 1 of the interview process.
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <!-- Interview Section -->
                    <section
                      v-if="jobDetail.customFields.automatic"
                      class="mt-3"
                    >
                      <div class="pubjobs-head fw-500">
                        No. of Interviews:
                        <span class="pubjobs-subheads fw-600">
                          {{ jobDetail.customFields.noOfInterviews }} Interviews
                          / ₹{{ costPerInterview }} each
                        </span>
                      </div>
                      <div
                        class="
                          pubjobs-head
                          fw-500
                          mt-2
                          d-flex
                          align-items-center
                        "
                      >
                        The interviews will take place on
                        <span
                          class="
                            pubjobs-subheads
                            fw-600
                            text-capitalize
                            ml-2
                            d-flex
                            align-items-center
                          "
                        >
                          <img
                            :src="
                              jobDetail.customFields.meetingPlatform === 'vccl'
                                ? require('@/assets/publishJobs/vccl.svg')
                                : require('@/assets/img/jddetails/teams.svg')
                            "
                            alt=""
                            class="mr-1"
                          />
                          {{
                            jobDetail.customFields.meetingPlatform === "vccl"
                              ? "VCCL"
                              : "Microsoft Teams"
                          }}
                        </span>
                      </div>
                    </section>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
        <div
          v-if="isPending"
          class="
            newJD-footer
            d-flex
            align-items-center
            justify-content-end
            w-100
            bluebtn
          "
        >
          <b-button
            @click="
              decision = 'reject';
              openAcceptReject = true;
            "
            class="acs-cancelBtn-modal mr-3"
            >Reject</b-button
          >
          <b-button
            @click="
              decision = 'approve';
              openAcceptReject = true;
            "
            class="acs-addBtn-modal pl-4 pr-4 mr-3"
            >Approve</b-button
          >
        </div>
      </div>

      <AllJobDetails
        v-if="showAllDetailsJD"
        :showAllDetailsJD="showAllDetailsJD"
        :jdDetailsType="jdDetailsType"
        :panelJdDetails="panelJdDetails"
        :allDetailDropDowns="allDetailDropDowns"
        :basicArray="basicArray"
        :advanceArray="advanceArray"
        @hideAllJobDetailsModal="hideAllJobDetailsModal"
      />
      <AcceptReject
        v-if="openAcceptReject"
        :openAcceptReject="openAcceptReject"
        :decision="decision"
        :title="jobDetail.title"
        :from="'job'"
        :jobID="jobDetail.jobID"
        :isExpired="isExpired"
        @close-accept-reject="closeAcceptReject"
      />
      <ConfigureTestModal :context="this" />
    </div>
  </transition>
</template>

<script>
import { getPerticularJobDescription } from "../../utils/apiFunctions.js";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
import ConfigureTestModal from "../../controllers/JD/modals/ConfigureTestModal.vue";
import AllJobDetails from "../../controllers/panelLogin/modals/AllJobDetails";
import AcceptReject from "../../controllers/OpsHeadApproval/Modal/AcceptReject.vue";
import { mapGetters } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getPanelJdDetails } from "../../controllers/panelLogin/asynchronous.js";
import EventBus from "../../utils/eventBus";
import { convertTime } from "../../controllers/workbench/helpers";

export default {
  name: "ReviewJds",
  data() {
    return {
      editor: ClassicEditor,

      // BOOLEAN
      addques1: false,
      addques2: false,
      globalWorks: false,
      questagmore: true,
      showalldet: false,
      showtopic: false,
      showtest: false,
      LoaderStatus: false,
      showAllDetailsJD: false,
      openAcceptReject: false,

      // STRINGS
      decision: "",
      testinstruction: "not_accepted",
      allDetailDropDowns: "openBasic",
      configName: "",
      roundid: "",
      ipname: "",
      tabname: this.$route.query.status,
      isExpired: "false",
      showTooltipPlace: null,

      // NUMBERS
      tabIndex: 0,
      selectedIPIndex: null,
      status: 2,
      jdDetailsType: null,

      // OBJECTS
      panelJdDetails: {},
      testConfigData: {
        config: {},
      },
      jobDetail: {
        title: "",
        jobType: [],
        description: [],
        role: [],
        educationQualification: [],
        experienceRequired: [],
        location: [],
        skills: [],
      },

      // ARRAYS
      noofrounds: [],
      selevaluator: [],
      greenTick: require("@/assets/publishJobs/greentick.svg"),
      xMark: require("@/assets/publishJobs/xmark.svg"),
    };
  },

  components: {
    AllJobDetails,
    AcceptReject,
    ConfigureTestModal,
  },

  props: {
    openPreview: Boolean,
    jobID: String,
    isPending: Boolean,
    customFieldsArray: Array,
    basicArray: Array,
    advanceArray: Array,
    costPerInterview: Number,
  },

  filters: {
    formatdate(data) {
      if (!data) return "-";
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },

    formatAssesmentDate(value) {
      if (!value) return "-";

      // Parse the ISO date
      let date = new Date(value);

      // Extract components
      let year = date.getUTCFullYear();
      let month = String(date.getUTCMonth() + 1).padStart(2, "0");
      let day = String(date.getUTCDate()).padStart(2, "0");
      let hours = date.getUTCHours();
      let minutes = String(date.getUTCMinutes()).padStart(2, "0");

      // Convert hours to 12-hour format and determine AM/PM
      let ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      hours = String(hours).padStart(2, "0");

      const dateTimeFormattedString =
        day +
        "-" +
        month +
        "-" +
        year +
        "\n" +
        hours +
        ":" +
        minutes +
        "\xa0" +
        ampm;

      return dateTimeFormattedString;
    },
  },

  watch: {
    openPreview(newVal) {
      if (newVal) {
        this.getJobDesc();
      }
    },
  },

  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    filteredCustFields() {
      let custFields = JSON.parse(JSON.stringify(this.customFieldsArray));
      let field = custFields.find((obj) => obj.key == "documents");
      if (field) {
        let docRequired = checkValuesOfKey(field, this.jobDetail);
        if (docRequired == "No") {
          custFields = custFields.filter(
            (obj) => obj.key != "requiredDocumets"
          );
        }
      }
      let roleField = custFields.find((obj) => obj.key == "role");
      if (roleField) {
        let roleValue = checkValuesOfKey(roleField, this.jobDetail);
        if (roleValue != "Others") {
          custFields = custFields.filter((obj) => obj.key != "otherRole");
        }
      }
      return custFields;
    },
    hasPlatforms() {
      return (
        this.jobDetail.openToPublic ||
        this.jobDetail.customFields.carrerPage ||
        this.jobDetail.customFields.naukri ||
        this.jobDetail.customFields.linkedIn
      );
    },
    hasNotifications() {
      return (
        this.jobDetail.customFields.mailNotification ||
        this.jobDetail.customFields.whatsAppNotification ||
        this.jobDetail.customFields.textNotification
      );
    },
    platforms() {
      return [
        {
          name: "openToPublic",
          label: "Job Platform",
          icon: require("@/assets/publishJobs/h3x.svg"),
          condition: this.jobDetail.openToPublic,
        },
        {
          name: "carrerPage",
          label: "Careers Page",
          icon: require("@/assets/publishJobs/h3x.svg"),
          condition: this.jobDetail.customFields.carrerPage,
        },
        {
          name: "linkedIn",
          label: "LinkedIn",
          icon: require("@/assets/publishJobs/linkedin.svg"),
          condition: this.jobDetail.customFields.linkedIn,
        },
        {
          name: "naukri",
          label: "Naukri",
          icon: require("@/assets/publishJobs/naukri.svg"),
          condition: this.jobDetail.customFields.naukri,
        },
      ];
    },
    notifications() {
      return [
        {
          name: "mailNotification",
          label: "Mail",
          icon: require("@/assets/publishJobs/mail.svg"),
          condition: this.jobDetail.customFields.mailNotification,
        },
        {
          name: "textNotification",
          label: "Text Message",
          icon: require("@/assets/publishJobs/txtmsg.svg"),
          condition: this.jobDetail.customFields.textNotification,
        },
        {
          name: "whatsAppNotification",
          label: "WhatsApp",
          icon: require("@/assets/publishJobs/whatsapp.svg"),
          condition: this.jobDetail.customFields.whatsAppNotification,
        },
      ];
    },
  },

  methods: {
    getConverted(date) {
      return convertTime(date, "india");
    },
    closeAcceptReject(type) {
      this.openAcceptReject = false;
      if (!type) EventBus.$emit("on-close-acceptreject");
    },
    hideAllJobDetailsModal() {
      this.showAllDetailsJD = false;
    },
    // Custom Field Functions
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.jobDetail);
    },

    isHtmlContent(field) {
      return isHtmlContent(field, this.jobDetail);
    },

    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.jobDetail);
    },

    async getPanelJdDetails(id, type) {
      const payload = {
        jobID: this.jobDetail.jobID,
        interviewRound: {
          id: id,
        },
      };
      this.showAllDetailsJD = true;
      this.jdDetailsType = type;
      await getPanelJdDetails(payload, this);
    },

    setUserIcon() {
      this.jobDetail.activity.forEach((activity) => {
        const name = activity.name;
        if (name.includes(" ")) {
          const [firstName, lastName] = name.split(" ");
          const firstInitial = firstName[0].toUpperCase();
          const lastInitial = lastName[0].toUpperCase();
          activity.userIcon = firstInitial + lastInitial;
        } else {
          const initials = name.slice(0, 2).toUpperCase();
          activity.userIcon = initials;
        }
      });
    },

    checkIsExpired() {
      const currentTime = new Date().toISOString();
      if (currentTime > this.jobDetail.endTime) {
        this.isExpired = "true";
      } else {
        this.isExpired = "false";
      }
    },

    viewConfig(index) {
      this.testConfigData.config = this.noofrounds[index].config;
      this.testConfigData.config.openTestdt = this.noofrounds[index].openTestdt;
      this.testConfigData.config.closeTestdt =
        this.noofrounds[index].closeTestdt;
      this.configName = this.noofrounds[index].configName;
      this.$bvModal.show("modal-1");
    },

    async getJobDesc() {
      this.LoaderStatus = true;
      let type = 2;

      try {
        const response = await getPerticularJobDescription(
          type,
          this.jobID,
          true
        );
        if (response.status == 200) {
          this.jobDetail = response.data.data;

          this.ipname = this.jobDetail.interviewProcess.name;
          this.noofrounds = this.jobDetail.interviewProcess.process.map(
            (item) => {
              return {
                ...item,
                expanded: item.id === 1,
              };
            }
          );

          this.checkIsExpired();
          this.setUserIcon();
        }
      } catch (error) {
        throw new Error(`Failed! getting jds ! status: ${error.status}`);
      }
      this.LoaderStatus = false;
    },

    toggleExpanded(id) {
      this.noofrounds = this.noofrounds.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            expanded: !item.expanded,
          };
        } else {
          return {
            ...item,
            expanded: false,
          };
        }
      });
    },
  },
};
</script>
<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

/* 125% */
@media screen and (max-width: 1536px) {
  .set-width-assessment {
    width: 90px;
  }

  .set-width-duration {
    width: 79px;
  }
}
</style>
